var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/DependencyTree/nodes/UserClassifierNodeContent/UserClassifierNodeContent.tsx";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import React from 'react';
import { NodeMoreActionButton } from '@gmini/ui-kit';
import { useHoverWithRef } from '@gmini/utils';
import { useDragLayer } from 'react-dnd';
import clsx from 'clsx';
import { ErrorButton } from "../../../SelectDependencies/ModelsTree/VersionButton/buttons/ErrorButton";
import { useBaseButtonStyles } from "../../../SelectDependencies/ModelsTree/VersionButton/buttons/buttonStyles";
import { NumCircleWrap, NumCircle, ErrorTooltip } from "../../../../components";
import { NodeLayout } from "../../NodeLayout";
import { NodeCheckbox } from "../../../ClassifierTree/NodeCheckbox";
import { NodeExpand } from "../../../NodeExpand";
import { useNodeCtxMenu } from "../../../ClassifierTree/TreeContextMenu/ctx";
import { getStyle } from "../../../Common/getStyle";
import { getClassifierIcon } from "../../../Common";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var UserClassifierNodeContent = function UserClassifierNodeContent(_ref) {
  var node = _ref.node,
      onClickNode = _ref.onClickNode,
      onDoubleClickNode = _ref.onDoubleClickNode,
      path = _ref.path,
      RenderNodeLayout = _ref.renderNodeLayout,
      checkbox = _ref.checkbox,
      onCheckedNode = _ref.onCheckedNode,
      isExpanded = _ref.isExpanded,
      onPending = _ref.onPending,
      isSelected = _ref.isSelected,
      onExpandClick = _ref.onExpandClick,
      clsDependencies = _ref.clsDependencies,
      inSearch = _ref.inSearch,
      highlighted = _ref.highlighted,
      inSearchSource = _ref.inSearchSource,
      error = _ref.error;

  var _useNodeCtxMenu = useNodeCtxMenu({
    path: path
  }),
      onContextMenu = _useNodeCtxMenu.onContextMenu,
      open = _useNodeCtxMenu.open,
      onClickOpen = _useNodeCtxMenu.onClickOpen;

  var matched = inSearch.matched,
      fullMatch = inSearch.fullMatch;
  var ref = React.useRef(null);

  var _useHoverWithRef = useHoverWithRef(ref),
      hover = _useHoverWithRef.hover,
      onMouseLeave = _useHoverWithRef.onMouseLeave,
      onMouseOver = _useHoverWithRef.onMouseOver;

  var depIdx = clsDependencies.findIndex(function (_ref2) {
    var id = _ref2.id;
    return id === node.id;
  });
  var classes = useBaseButtonStyles();
  var baseclassname = clsx(classes.root);
  var sourceCls = depIdx >= 0 ? clsDependencies[depIdx] : null;
  var expandable = 'total' in node && node.total > 0;
  var highlightedInSearch = false;

  var _useDragLayer = useDragLayer(function (monitor) {
    return {
      someoneDragging: monitor.isDragging()
    };
  }),
      someoneDragging = _useDragLayer.someoneDragging;

  if (matched) {
    if (fullMatch) {
      highlightedInSearch = true;
    } else if (!isExpanded) {
      highlightedInSearch = true;
    }
  }

  if (fullMatch || highlighted) {
    highlightedInSearch = true;
  }

  var style = getStyle({
    isSelected: isSelected,
    highlightedInSearch: highlightedInSearch,
    hover: open || hover,
    someoneDragging: someoneDragging,
    canDrop: false
  });
  var deepness = path.length - 1;
  var background = path.length === 1 && inSearchSource ? {
    background: '#F4F4F8'
  } : undefined;
  var errorText = typeof error === 'function' ? error(node) : error;
  var nodeLayoutProps = {
    ref: ref,
    icon: getClassifierIcon(node),
    text: node.name,
    onClick: onClickNode,
    onDoubleClick: onDoubleClickNode,
    onExpand: onExpandClick,
    onMouseLeave: onMouseLeave,
    onMouseOver: onMouseOver,
    onContextMenu: onContextMenu,
    expandJsx: /*#__PURE__*/_jsx(NodeExpand, {
      onClick: onExpandClick,
      expanded: isExpanded,
      hidden: !expandable,
      hovered: hover
    }),
    checkbox: /*#__PURE__*/_jsx(NodeCheckbox, _objectSpread(_objectSpread({}, checkbox), {}, {
      onChange: function onChange(_, value) {
        return onCheckedNode(value);
      }
    })),
    numCycle: sourceCls && /*#__PURE__*/_jsx(NumCircleWrap, {
      children: /*#__PURE__*/_jsx(NumCircle, {
        disabled: true,
        styleProps: path.length === 1 && inSearchSource ? {
          background: 'rgba(199, 200, 202, 1)',
          border: '1px solid rgba(199, 200, 202, 1)'
        } : undefined,
        children: depIdx + 1
      })
    }),
    // TODO вынести наверх либо в функцию для избавления от копипасты
    deepness: deepness,
    style: _objectSpread(_objectSpread({}, style), background),
    textStyle: {
      color: style.color
    },
    pending: onPending("UserClassifierGroup".concat(node.id)),
    //TODO pendingMap refactor,
    moreActionButton: /*#__PURE__*/_jsxs(_Fragment, {
      children: [errorText && /*#__PURE__*/_jsx(ErrorTooltip, {
        errorText: errorText,
        children: /*#__PURE__*/_jsx("span", {
          children: /*#__PURE__*/_jsx(ErrorButton, {
            className: baseclassname,
            children: node.version ? /*#__PURE__*/_jsxs("span", {
              className: classes.text,
              children: ["v", node.version]
            }) : null
          })
        })
      }), /*#__PURE__*/_jsx(NodeMoreActionButton, {
        show: hover || open,
        active: open,
        onClick: onClickOpen
      })]
    }),
    hover: hover,
    highlightedInSearch: highlightedInSearch
  };

  if (RenderNodeLayout) {
    return RenderNodeLayout({
      node: node,
      nodeLayoutProps: nodeLayoutProps,
      path: path
    });
  }

  return /*#__PURE__*/_jsx(NodeLayout, _objectSpread({}, nodeLayoutProps));
};